import { Box, Toolbar, Typography } from '@mui/material'
import React from 'react'

import DashboardCard from './component/Card'
import SplineChart from '../../../../components/Charts/Spline'
import BarChart from '../../../../components/Charts/BarChart'
import PieChart from '../../../../components/Charts/PieChart'
import { ChartHead } from '../Pages/Sales/Sales'
import { useGlobal } from '../../../../shared'
import { urls } from '../../../../shared/config'
import classes from './DashboardPage.module.css'

const DashboardPage = () => {
  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type

  const { data: cardData } = useGlobal({
    userUrl: `${urls.ANALYTICS}${customRole == 'Admin' ? userSchoolId : ''}`,
  })
  const { data: pieChart } = useGlobal({
    userUrl: `${urls.PIE_DATA}${customRole == 'Admin' ? userSchoolId : ''}`,
  })
  const cardItems = [
    { title: 'Grade', content: cardData?.grade },
    { title: 'Student', content: cardData?.student },
    { title: 'Teacher', content: cardData?.teacher },
    { title: 'Expense', content: `₹${cardData?.expense}` },
  ]

  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Dashboard'} subtitle={'Dashboard'} />

      <div className="dashboard-cards">
        {cardItems.map((card, index) => (
          <DashboardCard key={index} title={card.title} content={card.content} />
        ))}
      </div>
      <div className="chart-area">
        <div className="spline-chart chart-container">
          <SplineChart />
        </div>
        <div className="spline-chart chart-container">
          <BarChart />
        </div>
      </div>
      <Box className="chart-container" mt={5} sx={{ width: 'fit-content' }}>
        <ChartHead subheading={'Total Students'} heading={pieChart?.studentCount} />
        <PieChart data={pieChart} />
      </Box>
    </div>
  )
}

export default DashboardPage

export const DashboardHead = ({ profile, title, subtitle, sec, count,fees }) => {
  return (
    <div
      style={{
        flex: '1 0 0',
      }}
      className="dashboard-head"
    >
      {profile && sec ? (
        <>
          <div className={classes.lhs}>
            <img className={classes.profile} src={profile} alt="" />
            <Typography className="dashboard-title">{title}</Typography>
            <p className={classes.section}>{sec}</p>
          </div>
          <Typography className="dash-subtitle">{subtitle}</Typography>
        </>
      ) : (
        <>
          <div className={classes.lhs}>
            <Typography className="dashboard-title">{title}</Typography>

            {count && <p className={classes.txtx}>{count}</p>}
          </div>
          <Typography className="dash-subtitle">{subtitle}</Typography>
        </>
      )}
    </div>
  )
}
